<template>
  <div id="app" class="transfer-operation-page">
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat class="page-card">
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar dark color="info" class="page-toolbar">
              <v-toolbar-title>{{ $t('Transfer-Schedules') }}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-flex>

          <v-container fluid class="page-container">
            <v-card flat class="main-card">
              <v-tabs
                v-model="activeTab"
                color="white"
                slider-color="info"
                class="main-tabs"
              >
                <v-tab href="#agency" class="main-tab">
                  <v-icon left small>assignment</v-icon>
                  {{ $t('Agency-Transfer-Schedule') }}
                </v-tab>

                <v-tab href="#driver" class="main-tab">
                  <v-icon left small>local_taxi</v-icon>
                  {{ $t('Driver-Transfer-Schedule') }}
                </v-tab>

                <!-- AGENCY TRANSFER SCHEDULE -->
                <v-tab-item value="agency">
                  <v-card flat class="tab-content-card">
                    <v-form ref="formagency" v-model="validAgency" lazy-validation>
                      <v-card flat class="filter-card">
                        <v-card-text class="pb-0">
                          <div class="tab-header">
                            <div>
                              <div class="tab-title">{{ $t('Agency-Transfer-Schedule') }}</div>
                              <div class="tab-description">
                                {{ $t('Transfer-Schedule-Filter-Description') }}
                              </div>
                            </div>

                            <div class="tab-actions">
                              <v-btn
                                small
                                color="info"
                                dark
                                @click="getAgencyList()"
                                :loading="agencyListLoading"
                                :disabled="progress"
                              >
                                <v-icon left small>search</v-icon>
                                {{ $t('Get-List') }}
                              </v-btn>

                              <v-btn
                                small
                                color="orange darken-1"
                                dark
                                @click="resetAgencyChanges()"
                                :disabled="progress || agencyChangedCount === 0"
                              >
                                <v-icon left small>undo</v-icon>
                                {{ $t('Undo') }}
                              </v-btn>

                              <v-btn
                                small
                                color="primary"
                                dark
                                @click="downloadAgencyPdf()"
                                :loading="agencyPdfLoading"
                                :disabled="progress"
                              >
                                <v-icon left small>picture_as_pdf</v-icon>
                                {{ $t('Agency-PDF') }}
                              </v-btn>
                            </div>
                          </div>

                          <v-layout row wrap class="filter-row" align-center>
                            <v-flex xs12 sm6 md2>
                              <v-text-field
                                :label="$t('PNR-No-Optional')"
                                v-model="agencyFilter.pnrNo"
                                solo
                                flat
                                hide-details
                                type="number"
                                @keyup.enter="getAgencyList()"
                              ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm6 md2>
                              <tarihcomp
                                :etiket="$t('Starting-Date')"
                                :detaygizle="false"
                                :defaultvalue="'ok'"
                                :value="agencyFilter.startDate"
                                v-model="agencyFilter.startDate"
                              ></tarihcomp>
                            </v-flex>

                            <v-flex xs12 sm6 md2>
                              <tarihcomp
                                :etiket="$t('Finishing-Date')"
                                :detaygizle="false"
                                :defaultvalue="'ok'"
                                :value="agencyFilter.endDate"
                                v-model="agencyFilter.endDate"
                              ></tarihcomp>
                            </v-flex>

                            <v-flex xs12 sm6 md2>
                              <v-select
                                :label="$t('Transfer-Direction')"
                                item-value="value"
                                item-text="text"
                                :items="transferDirectionItems"
                                v-model="agencyFilter.transferDirection"
                                solo
                                flat
                                hide-details
                              ></v-select>
                            </v-flex>

                            <v-flex xs12 sm6 md2>
                              <v-select
                                :label="$t('Sort-By')"
                                item-value="value"
                                item-text="text"
                                :items="sortByItems"
                                v-model="agencyFilter.sortBy"
                                solo
                                flat
                                hide-details
                              ></v-select>
                            </v-flex>

                            <v-flex xs12 sm6 md2>
                              <v-select
                                :label="$t('Sort-Direction')"
                                item-value="value"
                                item-text="text"
                                :items="sortDirectionItems"
                                v-model="agencyFilter.sortDirection"
                                solo
                                flat
                                hide-details
                              ></v-select>
                            </v-flex>
                          </v-layout>

                          <v-layout row wrap class="summary-cards-row">
                            <v-flex xs12 sm6 md2>
                              <div class="summary-card summary-pnr">
                                <div class="summary-card-title">{{ $t('PNR') }}</div>
                                <div class="summary-card-value">{{ agencyFilter.pnrNo || "-" }}</div>
                              </div>
                            </v-flex>

                            <v-flex xs12 sm6 md3>
                              <div class="summary-card summary-date">
                                <div class="summary-card-title">{{ $t('Date') }}</div>
                                <div class="summary-card-value summary-card-value-small">
                                  {{ displayFilterDate(agencyFilter) }}
                                </div>
                              </div>
                            </v-flex>

                            <v-flex xs12 sm6 md2>
                              <div class="summary-card summary-direction">
                                <div class="summary-card-title">{{ $t('Direction') }}</div>
                                <div class="summary-card-value">{{ getDirectionText(agencyFilter.transferDirection) }}</div>
                              </div>
                            </v-flex>

                            <v-flex xs12 sm6 md2>
                              <div class="summary-card summary-count">
                                <div class="summary-card-title">{{ $t('Records') }}</div>
                                <div class="summary-card-value">{{ agencyItems.length }}</div>
                              </div>
                            </v-flex>

                            <v-flex xs12 sm6 md1>
                              <div class="summary-card summary-arrival">
                                <div class="summary-card-title">{{ $t('Arrival') }}</div>
                                <div class="summary-card-value">{{ agencyArrivalCount }}</div>
                              </div>
                            </v-flex>

                            <v-flex xs12 sm6 md1>
                              <div class="summary-card summary-departure">
                                <div class="summary-card-title">{{ $t('Departure') }}</div>
                                <div class="summary-card-value">{{ agencyDepartureCount }}</div>
                              </div>
                            </v-flex>

                            <v-flex xs12 sm6 md1>
                              <div class="summary-card summary-changed">
                                <div class="summary-card-title">{{ $t('Changes') }}</div>
                                <div class="summary-card-value">{{ agencyChangedCount }}</div>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>

                      <div class="table-info-row">
                        <div class="table-info">
                          <v-icon small color="info">edit</v-icon>
                          <span>{{ $t('Editable-Cells-Except-Reference-PNR') }}</span>
                        </div>
                      </div>

                      <ReportTable
                        :headers="agencyTableHeaders"
                        :items="agencyItems"
                        :loading="agencyListLoading || progress"
                        :has-searched="agencyHasSearched"
                        :storage-key="agencyReportTableStorageKey"
                        :search-label="$t('Search-In-Table')"
                        :show-frontend-export="true"
                        :rows-per-page-items="[20, 100]"
                        class="report-table-host"
                      >
                        <template slot="cell" slot-scope="slotProps">
                          <div
                            class="transfer-edit-cell"
                            :class="{
                              'transfer-edit-cell-readonly': isReadOnlyColumn(getColumnField(slotProps.column)),
                              'transfer-edit-cell-changed': isChangedCell('agency', slotProps.item, slotProps.column)
                            }"
                            @click.stop="openRowEditDialog('agency', slotProps.item)"
                          >
                            <span>
                              {{ displayReportTableCellValue(slotProps) }}
                            </span>
                          </div>
                        </template>
                      </ReportTable>

                      <div class="table-footer">
                        <span>{{ $t('Total-Records') }}: {{ agencyItems.length }}</span>
                        <span>{{ $t('Changed-Rows') }}: {{ agencyChangedCount }}</span>
                      </div>
                    </v-form>
                  </v-card>
                </v-tab-item>

                <!-- DRIVER TRANSFER SCHEDULE -->
                <v-tab-item value="driver">
                  <v-card flat class="tab-content-card">
                    <v-form ref="formdriver" v-model="validDriver" lazy-validation>
                      <v-card flat class="filter-card">
                        <v-card-text class="pb-0">
                          <div class="tab-header">
                            <div>
                              <div class="tab-title">{{ $t('Driver-Transfer-Schedule') }}</div>
                              <div class="tab-description">
                                {{ $t('Driver-Transfer-Schedule-Filter-Description') }}
                              </div>
                            </div>

                            <div class="tab-actions">
                              <v-btn
                                small
                                color="info"
                                dark
                                @click="getDriverList()"
                                :loading="driverListLoading"
                                :disabled="progress"
                              >
                                <v-icon left small>search</v-icon>
                                {{ $t('Get-List') }}
                              </v-btn>

                              <v-btn
                                small
                                color="orange darken-1"
                                dark
                                @click="resetDriverChanges()"
                                :disabled="progress || driverChangedCount === 0"
                              >
                                <v-icon left small>undo</v-icon>
                                {{ $t('Undo') }}
                              </v-btn>

                              <v-btn
                                small
                                color="green"
                                dark
                                @click="downloadDriverPdf()"
                                :loading="driverPdfLoading"
                                :disabled="progress"
                              >
                                <v-icon left small>picture_as_pdf</v-icon>
                                {{ $t('Driver-PDF') }}
                              </v-btn>
                            </div>
                          </div>

                          <v-layout row wrap class="filter-row" align-center>
                            <v-flex xs12 sm6 md2>
                              <v-text-field
                                :label="$t('PNR-No-Optional')"
                                v-model="driverFilter.pnrNo"
                                solo
                                flat
                                hide-details
                                type="number"
                                @keyup.enter="getDriverList()"
                              ></v-text-field>
                            </v-flex>

                            <v-flex xs12 sm6 md2>
                              <tarihcomp
                                :etiket="$t('Starting-Date')"
                                :detaygizle="false"
                                :defaultvalue="'ok'"
                                :value="driverFilter.startDate"
                                v-model="driverFilter.startDate"
                              ></tarihcomp>
                            </v-flex>

                            <v-flex xs12 sm6 md2>
                              <tarihcomp
                                :etiket="$t('Finishing-Date')"
                                :detaygizle="false"
                                :defaultvalue="'ok'"
                                :value="driverFilter.endDate"
                                v-model="driverFilter.endDate"
                              ></tarihcomp>
                            </v-flex>

                            <v-flex xs12 sm6 md2>
                              <v-select
                                :label="$t('Transfer-Direction')"
                                item-value="value"
                                item-text="text"
                                :items="transferDirectionItems"
                                v-model="driverFilter.transferDirection"
                                solo
                                flat
                                hide-details
                              ></v-select>
                            </v-flex>

                            <v-flex xs12 sm6 md2>
                              <v-select
                                :label="$t('Sort-By')"
                                item-value="value"
                                item-text="text"
                                :items="sortByItems"
                                v-model="driverFilter.sortBy"
                                solo
                                flat
                                hide-details
                              ></v-select>
                            </v-flex>

                            <v-flex xs12 sm6 md2>
                              <v-select
                                :label="$t('Sort-Direction')"
                                item-value="value"
                                item-text="text"
                                :items="sortDirectionItems"
                                v-model="driverFilter.sortDirection"
                                solo
                                flat
                                hide-details
                              ></v-select>
                            </v-flex>
                          </v-layout>

                          <v-layout row wrap class="summary-cards-row">
                            <v-flex xs12 sm6 md2>
                              <div class="summary-card summary-pnr">
                                <div class="summary-card-title">{{ $t('PNR') }}</div>
                                <div class="summary-card-value">{{ driverFilter.pnrNo || "-" }}</div>
                              </div>
                            </v-flex>

                            <v-flex xs12 sm6 md3>
                              <div class="summary-card summary-date">
                                <div class="summary-card-title">{{ $t('Date') }}</div>
                                <div class="summary-card-value summary-card-value-small">
                                  {{ displayFilterDate(driverFilter) }}
                                </div>
                              </div>
                            </v-flex>

                            <v-flex xs12 sm6 md2>
                              <div class="summary-card summary-direction">
                                <div class="summary-card-title">{{ $t('Direction') }}</div>
                                <div class="summary-card-value">{{ getDirectionText(driverFilter.transferDirection) }}</div>
                              </div>
                            </v-flex>

                            <v-flex xs12 sm6 md2>
                              <div class="summary-card summary-count">
                                <div class="summary-card-title">{{ $t('Records') }}</div>
                                <div class="summary-card-value">{{ driverItems.length }}</div>
                              </div>
                            </v-flex>

                            <v-flex xs12 sm6 md1>
                              <div class="summary-card summary-arrival">
                                <div class="summary-card-title">{{ $t('Arrival') }}</div>
                                <div class="summary-card-value">{{ driverArrivalCount }}</div>
                              </div>
                            </v-flex>

                            <v-flex xs12 sm6 md1>
                              <div class="summary-card summary-departure">
                                <div class="summary-card-title">{{ $t('Departure') }}</div>
                                <div class="summary-card-value">{{ driverDepartureCount }}</div>
                              </div>
                            </v-flex>

                            <v-flex xs12 sm6 md1>
                              <div class="summary-card summary-changed">
                                <div class="summary-card-title">{{ $t('Changes') }}</div>
                                <div class="summary-card-value">{{ driverChangedCount }}</div>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>

                      <div class="table-info-row">
                        <div class="table-info">
                          <v-icon small color="info">edit</v-icon>
                          <span>{{ $t('Editable-Cells-Except-Reference-PNR') }}</span>
                        </div>
                      </div>

                      <ReportTable
                        :headers="driverTableHeaders"
                        :items="driverItems"
                        :loading="driverListLoading || progress"
                        :has-searched="driverHasSearched"
                        :storage-key="driverReportTableStorageKey"
                        :search-label="$t('Search-In-Table')"
                        :show-frontend-export="true"
                        :rows-per-page-items="[20, 100]"
                        class="report-table-host"
                      >
                        <template slot="cell" slot-scope="slotProps">
                          <div
                            class="transfer-edit-cell"
                            :class="{
                              'transfer-edit-cell-readonly': isReadOnlyColumn(getColumnField(slotProps.column)),
                              'transfer-edit-cell-changed': isChangedCell('driver', slotProps.item, slotProps.column)
                            }"
                            @click.stop="openRowEditDialog('driver', slotProps.item)"
                          >
                            <span>
                              {{ displayReportTableCellValue(slotProps) }}
                            </span>
                          </div>
                        </template>
                      </ReportTable>

                      <div class="table-footer">
                        <span>{{ $t('Total-Records') }}: {{ driverItems.length }}</span>
                        <span>{{ $t('Changed-Rows') }}: {{ driverChangedCount }}</span>
                      </div>
                    </v-form>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </v-card>
          </v-container>


          <v-dialog
            v-model="rowEditDialog"
            persistent
            max-width="620"
          >
            <v-card class="row-edit-dialog-card">
              <v-card-title class="row-edit-dialog-title">
                <div>
                  <div class="row-edit-dialog-main-title">
                    {{ $t('Update') }}
                  </div>
                  <div class="row-edit-dialog-sub-title">
                    {{ rowEditDialogTitle }}
                  </div>
                </div>
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text class="row-edit-dialog-body">
                <v-layout row wrap>
                  <v-flex
                    xs12
                    sm12
                    md12
                    v-for="header in rowEditDialogHeaders"
                    :key="'row-edit-field-' + header.value"
                    class="row-edit-field-wrap"
                  >
                    <!-- Transfer satıcısı / Company alanı seçilebilir -->
                    <template v-if="header.value === 'Company'">
                      <v-layout row wrap align-end>
                        <v-flex xs11 sm11 md11>
                          <genelarama
                            :autofocuss="true"
                            apiname="SaticiAra"
                            :tip="2"
                            :label="getHeaderText(header)"
                            v-model="rowEditLookup.Company"
                            :disabled="rowEditLoading"
                          ></genelarama>
                        </v-flex>

                        <v-flex xs1 sm1 md1>
                          <v-layout row wrap fill-height align-end justify-center>
                            <minisaticieklecomp
                              v-model="rowEditLookup.Company"
                              :label="$t('Add-transfer-Seller')"
                              saticiKod="2"
                            ></minisaticieklecomp>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </template>

                    <!-- Hotel alanı seçilebilir -->
                    <template v-else-if="header.value === 'Hotel'">
                      <v-layout row wrap align-end>
                        <v-flex xs11 sm11 md11>
                          <genelarama
                            :autofocuss="true"
                            apiname="SaticiAra"
                            :tip="1"
                            :label="getHeaderText(header)"
                            v-model="rowEditLookup.Hotel"
                            :disabled="rowEditLoading"
                          ></genelarama>
                        </v-flex>

                        <v-flex xs1 sm1 md1>
                          <v-layout row wrap fill-height align-end justify-center>
                            <minisaticieklecomp
                              v-model="rowEditLookup.Hotel"
                              :label="$t('Add-hotel-Seller')"
                              saticiKod="1"
                            ></minisaticieklecomp>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </template>

                    <!-- Araç alanı seçilebilir -->
                    <template v-else-if="header.value === 'Vehicle'">
                      <aracalanara
                        :saticikodu="rowEditLookup.Company"
                        v-model="rowEditLookup.Vehicle"
                        :disabled="rowEditLoading"
                      ></aracalanara>
                    </template>

                    <!-- Rehber alanı seçilebilir -->
                    <template v-else-if="header.value === 'Guide' || header.value === 'RehberAd'">
                      <v-layout row wrap align-end>
                        <v-flex xs11 sm11 md11>
                          <genelarama
                            :autofocuss="true"
                            apiname="SaticiAra"
                            :tip="6"
                            :label="getHeaderText(header)"
                            v-model="rowEditLookup.Guide"
                            :disabled="rowEditLoading"
                          ></genelarama>
                        </v-flex>

                        <v-flex xs1 sm1 md1>
                          <v-layout row wrap fill-height align-end justify-center>
                            <minisaticieklecomp
                              v-model="rowEditLookup.Guide"
                              :label="$t('Add-guide-Seller')"
                              saticiKod="6"
                            ></minisaticieklecomp>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </template>

                    <!-- Taşıma tipi seçilebilir -->
                    <template v-else-if="header.value === 'TasimaTipi'">
                      <tasimatipi
                        v-model="rowEditForm[header.value]"
                        :disabled="rowEditLoading"
                      ></tasimatipi>
                    </template>

                    <!-- Direction seçilebilir -->
                    <template v-else-if="header.value === 'Direction'">
                      <v-select
                        :items="rowEditDirectionItems"
                        item-text="text"
                        item-value="value"
                        :label="getHeaderText(header)"
                        v-model="rowEditForm[header.value]"
                        :disabled="rowEditLoading"
                        hide-details
                        clearable
                        class="row-edit-field"
                      ></v-select>
                    </template>

                    <!-- Tarih alanları tarih componenti ile seçilebilir -->
                    <template v-else-if="isDateField(header.value)">
                      <tarihcomp
                        :etiket="getHeaderText(header)"
                        :detaygizle="true"
                        :defaultvalue="'no'"
                        :value="getDateComponentValue(rowEditForm[header.value])"
                        @input="setRowEditDateValue(header.value, $event)"
                      ></tarihcomp>
                    </template>

                    <!-- Saat alanları saat formatlı girilir -->
                    <template v-else-if="isTimeField(header.value)">
                      <v-text-field
                        :label="getHeaderText(header)"
                        v-model="rowEditForm[header.value]"
                        :disabled="rowEditLoading"
                        type="text"
                        mask="##:##"
                        placeholder="HH:mm"
                        clearable
                        return-masked-value
                        maxlength="5"
                        hide-details
                        class="row-edit-field"
                      ></v-text-field>
                    </template>

                    <!-- Diğer alanlar normal düzenlenir -->
                    <template v-else>
                      <v-text-field
                        :label="getHeaderText(header)"
                        v-model="rowEditForm[header.value]"
                        :readonly="isReadOnlyColumn(header.value)"
                        :disabled="rowEditLoading"
                        :clearable="!isReadOnlyColumn(header.value)"
                        hide-details
                        class="row-edit-field"
                      ></v-text-field>
                    </template>
                  </v-flex>
                </v-layout>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  flat
                  color="grey darken-1"
                  :disabled="rowEditLoading"
                  @click="closeRowEditDialog()"
                >
                  {{ $t('Cancel') }}
                </v-btn>

                <v-btn
                  flat
                  color="primary"
                  :loading="rowEditLoading"
                  :disabled="rowEditLoading"
                  @click="saveRowEditDialog()"
                >
                  {{ $t('Apply') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>


          <v-dialog
            v-model="loadingDialog"
            persistent
            width="380"
          >
            <v-card class="wait-dialog-card">
              <v-card-text class="wait-dialog-content">
                <v-progress-circular
                  indeterminate
                  color="info"
                  size="46"
                  width="4"
                ></v-progress-circular>

                <div class="wait-dialog-text">
                  <div class="wait-dialog-title">
                    {{ loadingDialogTitle }}
                  </div>
                  <div class="wait-dialog-message">
                    {{ loadingDialogMessage }}
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>

          <v-snackbar
            :timeout="timeout"
            :top="y === 'top'"
            :bottom="y === 'bottom'"
            :right="x === 'right'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'"
            v-model="snackbar"
          >
            {{ text1 }}
            <v-btn flat color="pink" @click="snackbar = false">
              {{ $t('Close') }}
            </v-btn>
          </v-snackbar>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>

<script>
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import tarihcomp from "../../customcomp/tarihim";
import tool from "../../coper/tools";
import ReportTable from "@/components/app/customcomp/ReportTable.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import tasimatipi from "@/components/app/coper/component/tasimatipi.vue";
import aracalanara from "@/components/app/coper/component/aracalanara.vue";
import minisaticieklecomp from "@/components/app/coper/component/minisaticieklecomp.vue";

function createAgencyHeaders() {
  return [
    { textKey: "Direction", value: "Direction", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px", editable: true },
    { textKey: "Reference", value: "Reference", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px", editable: false },
    { textKey: "Passenger-Name", value: "PassengerName", type: "text", align: "left", visible: true, sortable: true, minWidth: "260px", editable: true },
    { textKey: "Pax", value: "PassengerCount", type: "text", align: "right", visible: true, sortable: true, minWidth: "90px", editable: true },
    { textKey: "Hotel", value: "Hotel", type: "text", align: "left", visible: true, sortable: true, minWidth: "220px", editable: true },
    { textKey: "Flight-No", value: "FlightNo", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px", editable: true },
    { textKey: "Flight-Time", value: "FlightTime", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px", editable: true },
    { textKey: "Pickup-Time", value: "PickupTime", type: "text", align: "left", visible: true, sortable: true, minWidth: "140px", editable: true },
    { textKey: "Vehicle", value: "Vehicle", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px", editable: true },
    { textKey: "Company", value: "Company", type: "text", align: "left", visible: true, sortable: true, minWidth: "190px", editable: true },
    { text: "From", value: "From", type: "text", align: "left", visible: true, sortable: true, minWidth: "180px", editable: true },
    { text: "To", value: "To", type: "text", align: "left", visible: true, sortable: true, minWidth: "180px", editable: true },
    { textKey: "Route", value: "Route", type: "text", align: "left", visible: false, sortable: true, minWidth: "220px", editable: true, showInDialog: false },
    { textKey: "Room-No", value: "RoomNo", type: "text", align: "left", visible: true, sortable: true, minWidth: "120px", editable: true },
    { textKey: "Note", value: "Note", type: "text", align: "left", visible: true, sortable: true, minWidth: "240px", editable: true }
  ];
}

function createDriverHeaders() {
  return [
    { textKey: "Date", value: "Date", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px", editable: true },
    { textKey: "Time", value: "Time", type: "text", align: "left", visible: true, sortable: true, minWidth: "110px", editable: true },
    { textKey: "TRF-DISPO", value: "Direction", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px", editable: true },
    { textKey: "Reference", value: "Reference", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px", editable: false },
    { textKey: "Flight", value: "FlightNo", type: "text", align: "left", visible: true, sortable: true, minWidth: "130px", editable: true },
    { textKey: "Pickup-Point", value: "PickupPoint", type: "text", align: "left", visible: true, sortable: true, minWidth: "180px", editable: true },
    { textKey: "Drop-Point", value: "DropPoint", type: "text", align: "left", visible: true, sortable: true, minWidth: "180px", editable: true },
    { textKey: "Hotel", value: "Hotel", type: "text", align: "left", visible: true, sortable: true, minWidth: "220px", editable: true },
    { textKey: "Pax", value: "PassengerCount", type: "text", align: "right", visible: true, sortable: true, minWidth: "90px", editable: true },
    { textKey: "Vehicle", value: "Vehicle", type: "text", align: "left", visible: true, sortable: true, minWidth: "150px", editable: true },
    { textKey: "Company", value: "Company", type: "text", align: "left", visible: true, sortable: true, minWidth: "180px", editable: true },
    { textKey: "Note", value: "Note", type: "text", align: "left", visible: true, sortable: true, minWidth: "220px", editable: true }
  ];
}

function beforeMount() {}

export default {
  name: "TransferOperationSchedules",
  beforeMount,
  components: {
    hatadialog,
    tarihcomp,
    ReportTable,
    genelarama,
    tasimatipi,
    aracalanara,
    minisaticieklecomp
  },
  data() {
    return {
      activeTab: "agency",

      validAgency: true,
      validDriver: true,

      agencyHeaders: createAgencyHeaders(),
      driverHeaders: createDriverHeaders(),

      agencyItems: [],
      driverItems: [],

      agencyOriginalItems: [],
      driverOriginalItems: [],

      agencyHasSearched: false,
      driverHasSearched: false,

      editingCell: {
        tableName: "",
        rowKey: "",
        field: ""
      },

      rowEditDialog: false,
      rowEditLoading: false,
      rowEditTableName: "",
      rowEditOriginalRow: null,
      rowEditForm: {},
      rowEditLookup: {
        Company: null,
        Hotel: null,
        Vehicle: null,
        Guide: null
      },

      agencyFilter: {
        startDate: null,
        endDate: null,
        pnrNo: null,
        transferDirection: "all",
        sortBy: "dateTime",
        sortDirection: "asc"
      },

      driverFilter: {
        startDate: null,
        endDate: null,
        pnrNo: null,
        transferDirection: "all",
        sortBy: "dateTime",
        sortDirection: "asc"
      },

      loadingDialog: false,
      loadingDialogTitle: this.$t("Please-Wait"),
      loadingDialogMessage: this.$t("Operation-Is-Being-Prepared"),

      progress: false,
      agencyListLoading: false,
      driverListLoading: false,
      agencyPdfLoading: false,
      driverPdfLoading: false,

      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: ""
    };
  },
  computed: {
    agencyTableHeaders() {
      return this.translateHeaders(this.agencyHeaders);
    },
    driverTableHeaders() {
      return this.translateHeaders(this.driverHeaders);
    },
    rowEditDialogHeaders() {
      var headers = this.rowEditTableName === "driver"
        ? this.driverTableHeaders
        : this.agencyTableHeaders;

      return headers.filter(function(header) {
        return header.showInDialog !== false && header.visible !== false;
      });
    },
    rowEditDirectionItems() {
      return [
        { text: this.$t("Arrival"), value: "Arrival" },
        { text: this.$t("Departure"), value: "Departure" },
        { text: "Transfer", value: "Transfer" },
        { text: "Dispo", value: "Dispo" }
      ];
    },
    rowEditDialogTitle() {
      if (this.rowEditTableName === "driver") {
        return this.$t("Driver-Transfer-Schedule");
      }

      return this.$t("Agency-Transfer-Schedule");
    },
    transferDirectionItems() {
      return [
        { text: this.$t("All"), value: "all" },
        { text: this.$t("Arrival"), value: "arrival" },
        { text: this.$t("Departure"), value: "departure" }
      ];
    },
    sortByItems() {
      return [
        { text: this.$t("Date-Time"), value: "dateTime" },
        { text: this.$t("Date"), value: "date" },
        { text: this.$t("Time"), value: "time" },
        { text: this.$t("Pickup-Point"), value: "pickupPoint" },
        { text: this.$t("Vehicle"), value: "vehicle" },
        { text: this.$t("Pax"), value: "pax" },
        { text: this.$t("Flight"), value: "flight" },
        { text: this.$t("Hotel"), value: "hotel" }
      ];
    },
    sortDirectionItems() {
      return [
        { text: this.$t("Ascending"), value: "asc" },
        { text: this.$t("Descending"), value: "desc" }
      ];
    },
    agencyReportTableStorageKey() {
      return "transfer_operation_report_table_agency_only_table_columns";
    },
    driverReportTableStorageKey() {
      return "transfer_operation_report_table_driver_only_table_columns";
    },
    agencyArrivalCount() {
      return this.countByDirection(this.agencyItems, "Arrival");
    },
    agencyDepartureCount() {
      return this.countByDirection(this.agencyItems, "Departure");
    },
    driverArrivalCount() {
      return this.countByDirection(this.driverItems, "Arrival");
    },
    driverDepartureCount() {
      return this.countByDirection(this.driverItems, "Departure");
    },
    agencyChangedCount() {
      return this.countChangedRows(this.agencyItems, this.agencyOriginalItems, this.agencyHeaders);
    },
    driverChangedCount() {
      return this.countChangedRows(this.driverItems, this.driverOriginalItems, this.driverHeaders);
    }
  },
  methods: {
    translateHeaders(headers) {
      if (!Array.isArray(headers)) {
        return [];
      }

      return headers.map((header) => {
        var translatedHeader = {};

        for (var prop in header) {
          if (Object.prototype.hasOwnProperty.call(header, prop)) {
            translatedHeader[prop] = header[prop];
          }
        }

        translatedHeader.text = header.textKey
          ? this.$t(header.textKey)
          : header.text;

        return translatedHeader;
      });
    },
    getHeaderText(header) {
      if (!header) {
        return "";
      }

      if (header.text) {
        return header.text;
      }

      if (header.textKey) {
        return this.$t(header.textKey);
      }

      return "";
    },
    isDateField(field) {
      var dateFields = [
        "Date",
        "Donem1",
        "Donem2"
      ];

      return dateFields.indexOf(field) > -1;
    },
    isTimeField(field) {
      var timeFields = [
        "Time",
        "FlightTime",
        "PickupTime",
        "UcusSaat",
        "Saat"
      ];

      return timeFields.indexOf(field) > -1;
    },
    getDateComponentValue(value) {
      // tarihcomp dd.MM.yyyy değeri ekranda boş gösterebiliyor.
      // Component'e ISO yyyy-MM-dd veriyoruz, tablo/PDF tarafında yine formatlama yapılıyor.
      return this.formatDateForApi(value);
    },
    setRowEditDateValue(field, value) {
      this.$set(this.rowEditForm, field, value);
    },
    createLookupObject(code, name, tip) {
      var cleanCode = code == null ? "" : String(code).trim();
      var cleanName = name == null ? "" : String(name).trim();

      if (!cleanCode && !cleanName) {
        return null;
      }

      return {
        YurtIci_YurtDisi: 0,
        CariKod: null,
        KDV: 0,
        Yer: null,
        Ulke: null,
        Sehir: null,
        SaticiKonumu: null,
        Web: null,
        Tel1: null,
        Tel2: null,
        Fax: null,
        Teleks: null,
        EMail: null,
        GSM: null,
        Adres: null,
        id: "0",
        kod: cleanCode,
        isim: cleanName || cleanCode,
        isimAra: "",
        tip: 0,
        intField: null,
        tumSirketler: false,
        sayfaAdi: null,
        saticiTip: tip || 0
      };
    },
    isLookupErrorText(value) {
      if (value == null) {
        return false;
      }

      var text = String(value).trim().toLowerCase();

      return text.indexOf("hata") > -1 && text.indexOf("kod") > -1;
    },
    cleanLookupText(value) {
      if (value == null) {
        return "";
      }

      var text = String(value).trim();

      if (!text || this.isLookupErrorText(text)) {
        return "";
      }

      return text;
    },
    getLookupCode(value) {
      if (value == null || value === "") {
        return "";
      }

      if (typeof value === "object") {
        return this.cleanLookupText(value.kod || value.Kod || value.code || value.Code || "");
      }

      return this.cleanLookupText(value);
    },
    getLookupName(value) {
      if (value == null || value === "") {
        return "";
      }

      if (typeof value === "object") {
        return this.cleanLookupText(
          value.isim || value.Isim || value.ad || value.Ad || value.name || value.Name || value.kod || value.Kod || ""
        );
      }

      return this.cleanLookupText(value);
    },
    cloneLookupObject(value) {
      if (!value || typeof value !== "object") {
        return null;
      }

      try {
        return JSON.parse(JSON.stringify(value));
      } catch (e) {
        var clone = {};

        for (var prop in value) {
          if (Object.prototype.hasOwnProperty.call(value, prop)) {
            clone[prop] = value[prop];
          }
        }

        return clone;
      }
    },
    normalizeLookupObject(value, fallbackCode, fallbackName, tip) {
      var code = this.getLookupCode(value) || this.cleanLookupText(fallbackCode);
      var name = this.getLookupName(value) || this.cleanLookupText(fallbackName) || code;

      if (!code && !name) {
        return null;
      }

      var obj = this.cloneLookupObject(value) || this.createLookupObject(code, name, tip);

      if (!obj) {
        return null;
      }

      obj.kod = code;
      obj.Kod = code;
      obj.isim = name;
      obj.Isim = name;

      if (tip != null) {
        obj.saticiTip = tip;
      }

      return obj;
    },
    buildRowEditLookup(form, item) {
      return {
        Company: this.createLookupObject(
          form.SaticiKod || item.SaticiKod || item.saticiKod,
          form.Company || item.Company || item.SaticiAd || item.saticiAd,
          2
        ),
        Hotel: this.createLookupObject(
          form.OtelKod || item.OtelKod || item.HotelCode || item.hotelCode,
          form.Hotel || item.Hotel || item.OtelAd || item.otelAd,
          1
        ),
        Vehicle: form.Vehicle || item.Vehicle || item.Arac || item.arac || "",
        Guide: this.createLookupObject(
          form.Rehber || item.Rehber || item.RehberKod || item.rehberKod,
          form.Guide || item.Guide || item.RehberAd || item.rehberAd,
          6
        )
      };
    },
    syncLookupFieldsToForm() {
      var companyCode = this.getLookupCode(this.rowEditLookup.Company);
      var companyName = this.getLookupName(this.rowEditLookup.Company);

      if (companyCode || companyName) {
        this.$set(this.rowEditForm, "SaticiKod", companyCode);
        this.$set(this.rowEditForm, "Company", companyName || companyCode);
      }

      var hotelCode = this.getLookupCode(this.rowEditLookup.Hotel);
      var hotelName = this.getLookupName(this.rowEditLookup.Hotel);

      if (hotelCode || hotelName) {
        this.$set(this.rowEditForm, "OtelKod", hotelCode);
        this.$set(this.rowEditForm, "Hotel", hotelName || hotelCode);
      }

      var vehicleCode = this.getLookupCode(this.rowEditLookup.Vehicle);
      var vehicleName = this.getLookupName(this.rowEditLookup.Vehicle);

      if (vehicleCode || vehicleName) {
        this.$set(this.rowEditForm, "Arac", vehicleCode || vehicleName);
        this.$set(this.rowEditForm, "Vehicle", vehicleName || vehicleCode);
      }

      var guideCode = this.getLookupCode(this.rowEditLookup.Guide);
      var guideName = this.getLookupName(this.rowEditLookup.Guide);

      if (guideCode || guideName) {
        this.$set(this.rowEditForm, "Rehber", guideCode);
        this.$set(this.rowEditForm, "Guide", guideName || guideCode);
        this.$set(this.rowEditForm, "RehberAd", guideName || guideCode);
      }
    },
    getFirstExistingValue(source, fieldNames) {
      if (!source || !Array.isArray(fieldNames)) {
        return "";
      }

      for (var i = 0; i < fieldNames.length; i++) {
        var fieldName = fieldNames[i];

        if (source[fieldName] != null && source[fieldName] !== "") {
          return source[fieldName];
        }
      }

      return "";
    },
    normalizeDateForRowDisplay(value) {
      if (!value) {
        return "";
      }

      var apiDate = this.formatDateForApi(value);

      if (!apiDate) {
        return "";
      }

      return this.formatDateForDisplay(apiDate);
    },
    normalizeDateForSave(value) {
      var apiDate = this.formatDateForApi(value);

      if (!apiDate) {
        return "";
      }

      return apiDate;
    },
    getReservationTransferItemDate(item) {
      if (!item) {
        return "";
      }

      var dateValue = this.getFirstExistingValue(item, [
        "donem1",
        "Donem1",
        "DONEM1",
        "date",
        "Date",
        "Tarih"
      ]);

      if (!dateValue && item.kalemArac) {
        dateValue = this.getFirstExistingValue(item.kalemArac, [
          "tarih",
          "Tarih",
          "transferTarihi",
          "TransferTarihi"
        ]);
      }

      if (!dateValue && item.KalemArac) {
        dateValue = this.getFirstExistingValue(item.KalemArac, [
          "tarih",
          "Tarih",
          "transferTarihi",
          "TransferTarihi"
        ]);
      }

      return this.normalizeDateForRowDisplay(dateValue);
    },
    hydrateDriverDateFromReservation(item) {
      if (!item || this.rowEditTableName !== "driver") {
        return;
      }

      if (this.rowEditForm && this.rowEditForm.Date) {
        return;
      }

      var pnrNo = this.getRowPnrNo(item);

      if (!pnrNo) {
        return;
      }

      var loadParams = {
        PNR_No: pnrNo
      };

      tool.http_post(this, "RezervasyonLoad", loadParams)
        .then((response) => {
          if (!this.rowEditDialog || this.rowEditTableName !== "driver") {
            return;
          }

          if (!response.body || response.body.Status !== true || !response.body.data) {
            return;
          }

          var targetItem = this.findReservationTransferItem(response.body.data, item);

          if (!targetItem) {
            return;
          }

          var dateValue = this.getReservationTransferItemDate(targetItem);

          if (dateValue) {
            this.$set(this.rowEditForm, "Date", dateValue);
          }
        })
        .catch(() => {});
    },
    openRowEditDialog(tableName, item) {
      if (!item || this.progress) {
        return;
      }

      this.stopEditCell();

      var headers = tableName === "driver"
        ? this.driverTableHeaders
        : this.agencyTableHeaders;

      var form = {};

      for (var i = 0; i < headers.length; i++) {
        var field = headers[i].value;
        form[field] = item[field] == null ? "" : item[field];
      }

      // Bu alanlar tabloda/kolon menüsünde gösterilmiyor.
      // Sadece seçilebilir dialog componentlerinden gelen kodları RezervasyonKaydet'e doğru basmak için tutuluyor.
      form.SaticiKod = item.SaticiKod || item.saticiKod || "";
      form.OtelKod = item.OtelKod || item.otelKod || item.HotelCode || item.hotelCode || "";
      form.Rehber = item.Rehber || item.rehber || item.RehberKod || item.rehberKod || "";
      form.Guide = item.Guide || item.RehberAd || item.rehberAd || "";
      form.Arac = item.Arac || item.arac || "";
      form.TurKodu = item.TurKodu || item.turKodu || item.TourCode || item.tourCode || "";
      form.TasimaTipi = item.TasimaTipi || item.tasimaTipi || "";

      // Acenta tablosunda Route eski birleşik alan olarak kalıyor.
      // From / To ayrı kolonları boş geldiyse Route üzerinden dolduruyoruz.
      if (tableName === "agency") {
        var routeParts = this.splitRouteText(form.Route);

        if (!form.From) {
          form.From = item.From || item.from || item.Nerden || item.nerden || item.PickupPoint || routeParts.from || "";
        }

        if (!form.To) {
          form.To = item.To || item.to || item.Nereye || item.nereye || item.DropPoint || routeParts.to || "";
        }

        form.Route = this.buildRouteText(form.From, form.To) || form.Route || "";
      }

      // Sürücü tablosunda backend bazı durumlarda Date yerine Donem1/Tarih/transferTarihi gönderebiliyor.
      // Dialog boş açılmasın diye tüm olası alanlardan tarihi normalize edip Date'e basıyoruz.
      if (tableName === "driver" && !form.Date) {
        form.Date = this.normalizeDateForRowDisplay(
          this.getFirstExistingValue(item, [
            "Date",
            "date",
            "Tarih",
            "tarih",
            "Donem1",
            "donem1",
            "DONEM1",
            "TransferDate",
            "transferDate",
            "OperationDate",
            "operationDate"
          ])
        );
      }

      if (!form.Guide && item.RehberAd) {
        form.Guide = item.RehberAd;
      }

      if (!form.TurKodu && item.TourCode) {
        form.TurKodu = item.TourCode;
      }

      this.rowEditTableName = tableName;
      this.rowEditOriginalRow = item;
      this.rowEditForm = form;
      this.rowEditLookup = this.buildRowEditLookup(form, item);
      this.rowEditDialog = true;

      // Eğer liste response'unda hiç tarih yoksa, PNR'ı load edip transfer kalemindeki donem1'i dialog'a bas.
      if (tableName === "driver" && !this.rowEditForm.Date) {
        this.hydrateDriverDateFromReservation(item);
      }
    },
    closeRowEditDialog() {
      if (this.rowEditLoading) {
        return;
      }

      this.rowEditDialog = false;
      this.rowEditTableName = "";
      this.rowEditOriginalRow = null;
      this.rowEditForm = {};
      this.rowEditLookup = {
        Company: null,
        Hotel: null,
        Vehicle: null,
        Guide: null
      };
    },
    getRowPnrNo(row) {
      if (!row) {
        return null;
      }

      var fields = [
        "Reference",
        "PNR_No",
        "pNR_No",
        "PnrNo",
        "pnrNo",
        "PNR",
        "Pnr"
      ];

      for (var i = 0; i < fields.length; i++) {
        var value = row[fields[i]];

        if (value == null || value === "") {
          continue;
        }

        var parsed = Number(String(value).trim());

        if (parsed && parsed > 0) {
          return parsed;
        }
      }

      return null;
    },
    normalizeCompareValue(value) {
      if (value == null) {
        return "";
      }

      return String(value)
        .trim()
        .toLowerCase()
        .replace(/\s+/g, " ");
    },
    normalizeTimeValue(value) {
      if (value == null) {
        return "";
      }

      var text = String(value).trim();

      if (!text) {
        return "";
      }

      var match = text.match(/(\d{1,2}):(\d{2})/);

      if (match) {
        var hour = Number(match[1]);
        var minute = match[2];

        if (hour < 10) {
          return "0" + hour + ":" + minute;
        }

        return hour + ":" + minute;
      }

      return this.normalizeCompareValue(text);
    },
    valuesEqualForMatch(a, b) {
      var left = this.normalizeCompareValue(a);
      var right = this.normalizeCompareValue(b);

      if (!left || !right) {
        return false;
      }

      return left === right;
    },
    getNestedValue(source, path) {
      if (!source || !path) {
        return null;
      }

      var parts = path.split(".");
      var current = source;

      for (var i = 0; i < parts.length; i++) {
        if (current == null) {
          return null;
        }

        current = current[parts[i]];
      }

      return current;
    },
    setNestedValue(source, path, value) {
      if (!source || !path) {
        return;
      }

      var parts = path.split(".");
      var current = source;

      for (var i = 0; i < parts.length - 1; i++) {
        var part = parts[i];

        if (current[part] == null) {
          current[part] = {};
        }

        current = current[part];
      }

      current[parts[parts.length - 1]] = value;
    },
    setNestedValues(source, paths, value) {
      if (!source || !Array.isArray(paths)) {
        return;
      }

      for (var i = 0; i < paths.length; i++) {
        this.setNestedValue(source, paths[i], value);
      }
    },
    isTransferReservationItem(item) {
      if (!item) {
        return false;
      }

      var saticiTip = item.saticiTip || item.SaticiTip;

      if (!saticiTip && item.satici) {
        saticiTip = item.satici.saticiTip || item.satici.SaticiTip;
      }

      var text = String(saticiTip || "").trim();

      return text === "2" || text === "02";
    },
    getReservationItemIdValue(item, field) {
      if (!item || !field) {
        return "";
      }

      var candidates = [
        field,
        field.charAt(0).toLowerCase() + field.slice(1),
        field.charAt(0).toUpperCase() + field.slice(1)
      ];

      for (var i = 0; i < candidates.length; i++) {
        var value = item[candidates[i]];

        if (value != null && value !== "") {
          return String(value);
        }
      }

      return "";
    },
    findReservationTransferItem(rezervasyon, row) {
      var kalemler = rezervasyon && Array.isArray(rezervasyon.kalemler)
        ? rezervasyon.kalemler
        : [];

      var transferKalemler = kalemler.filter((item) => {
        return this.isTransferReservationItem(item);
      });

      if (transferKalemler.length === 0) {
        return null;
      }

      var idPairs = [
        { row: "IslemRef", item: "islemRef" },
        { row: "islemRef", item: "islemRef" },
        { row: "EntId", item: "entId" },
        { row: "entId", item: "entId" },
        { row: "KalemId", item: "id" },
        { row: "kalemId", item: "id" },
        { row: "Id", item: "id" },
        { row: "ID", item: "ID" }
      ];

      for (var p = 0; p < idPairs.length; p++) {
        var rowValue = row ? row[idPairs[p].row] : null;

        if (rowValue == null || rowValue === "") {
          continue;
        }

        for (var i = 0; i < transferKalemler.length; i++) {
          var itemValue = this.getReservationItemIdValue(transferKalemler[i], idPairs[p].item);

          if (String(rowValue) === String(itemValue)) {
            return transferKalemler[i];
          }
        }
      }

      var rowFlight = this.normalizeCompareValue(row && row.FlightNo);
      var rowTime = this.normalizeTimeValue(
        row && (row.Time || row.PickupTime || row.FlightTime)
      );
      var rowPickupPoint = this.normalizeCompareValue(
        row && (row.PickupPoint || row.From || row.Nerden)
      );
      var rowDropPoint = this.normalizeCompareValue(
        row && (row.DropPoint || row.To || row.Nereye)
      );

      var matchedItems = transferKalemler.filter((item) => {
        var kalemArac = item.kalemArac || item.KalemArac || {};

        var itemFlight = this.normalizeCompareValue(
          kalemArac.ucusNo || kalemArac.UcusNo || item.ucusNo || item.UcusNo
        );

        var itemTime = this.normalizeTimeValue(
          kalemArac.seferSaat ||
          kalemArac.SeferSaat ||
          kalemArac.ucusSaat ||
          kalemArac.UcusSaat ||
          item.seferSaat ||
          item.ucusSaat
        );

        var itemPickupPoint = this.normalizeCompareValue(
          kalemArac.nerden || kalemArac.Nerden || item.nerden || item.Nerden
        );

        var itemDropPoint = this.normalizeCompareValue(
          kalemArac.nereye || kalemArac.Nereye || item.nereye || item.Nereye
        );

        var score = 0;

        if (rowFlight && itemFlight && rowFlight === itemFlight) {
          score++;
        }

        if (rowTime && itemTime && rowTime === itemTime) {
          score++;
        }

        if (rowPickupPoint && itemPickupPoint && rowPickupPoint === itemPickupPoint) {
          score++;
        }

        if (rowDropPoint && itemDropPoint && rowDropPoint === itemDropPoint) {
          score++;
        }

        return score >= 2;
      });

      if (matchedItems.length === 1) {
        return matchedItems[0];
      }

      if (transferKalemler.length === 1) {
        return transferKalemler[0];
      }

      return null;
    },
    applyEditedRowToReservationItem(item, row) {
      if (!item || !row) {
        return;
      }

      if (!item.kalemArac && !item.KalemArac) {
        item.kalemArac = {};
      }

      var kalemAracPath = item.kalemArac ? "kalemArac" : "KalemArac";

      var companyCode = row.SaticiKod || row.saticiKod || "";
      var companyName = row.Company || row.SaticiAd || row.saticiAd || "";
      var hotelCode = row.OtelKod || row.otelKod || row.HotelCode || row.hotelCode || "";
      var hotelName = row.Hotel || row.OtelAd || row.otelAd || "";
      var vehicleCode = row.Arac || row.arac || "";
      var vehicleName = row.Vehicle || row.AracPlaka || row.aracPlaka || vehicleCode;
      var guideCode = row.Rehber || row.rehber || row.RehberKod || row.rehberKod || "";
      var guideName = row.Guide || row.RehberAd || row.rehberAd || guideCode;

      this.setNestedValues(item, [
        kalemAracPath + ".ucusNo",
        kalemAracPath + ".UcusNo",
        "ucusNo",
        "UcusNo"
      ], row.FlightNo);

      this.setNestedValues(item, [
        kalemAracPath + ".ucusSaat",
        kalemAracPath + ".UcusSaat",
        "ucusSaat",
        "UcusSaat"
      ], row.FlightTime || row.Time);

      this.setNestedValues(item, [
        kalemAracPath + ".seferSaat",
        kalemAracPath + ".SeferSaat",
        "seferSaat",
        "SeferSaat"
      ], row.PickupTime || row.Time);

      this.setNestedValues(item, [
        kalemAracPath + ".nerden",
        kalemAracPath + ".Nerden",
        "nerden",
        "Nerden"
      ], row.PickupPoint || row.From);

      this.setNestedValues(item, [
        kalemAracPath + ".nereye",
        kalemAracPath + ".Nereye",
        "nereye",
        "Nereye"
      ], row.DropPoint || row.To);

      this.setNestedValues(item, [
        kalemAracPath + ".arac",
        kalemAracPath + ".Arac",
        kalemAracPath + ".aracKod",
        kalemAracPath + ".AracKod",
        "arac",
        "Arac"
      ], vehicleCode || vehicleName);

      this.setNestedValues(item, [
        kalemAracPath + ".aracPlaka",
        kalemAracPath + ".AracPlaka",
        kalemAracPath + ".aracAd",
        kalemAracPath + ".AracAd"
      ], vehicleName || vehicleCode);

      this.setNestedValues(item, [
        kalemAracPath + ".aracAdet",
        kalemAracPath + ".AracAdet"
      ], row.VehicleCount);

      this.setNestedValues(item, [
        kalemAracPath + ".ADT",
        kalemAracPath + ".adt",
        "kisiAdet",
        "KisiAdet"
      ], row.PassengerCount);

      var hotelObject = this.normalizeLookupObject(
        this.rowEditLookup ? this.rowEditLookup.Hotel : null,
        hotelCode,
        hotelName,
        1
      );

      var safeHotelCode = hotelObject ? this.getLookupCode(hotelObject) : hotelCode;
      var safeHotelName = hotelObject ? this.getLookupName(hotelObject) : hotelName;
      var originalHotelName = this.rowEditOriginalRow ? this.normalizeCompareValue(this.rowEditOriginalRow.Hotel) : "";
      var currentHotelName = this.normalizeCompareValue(safeHotelName || row.Hotel);
      var hotelChanged = currentHotelName && currentHotelName !== originalHotelName;

      if (hotelChanged && hotelObject) {
        // Transfer kaleminde otel alanı object olarak tutuluyor.
        // Seçilen genelarama objesini id/kod/isim bilgilerini kaybetmeden gönderiyoruz.
        // Kod yoksa ismi kod yerine yazmıyoruz; aksi halde backend "Hata, Kod bulunamadı" döndürebiliyor.
        this.setNestedValues(item, [
          kalemAracPath + ".otelKod",
          kalemAracPath + ".OtelKod"
        ], hotelObject);

        this.setNestedValues(item, [
          kalemAracPath + ".otel",
          kalemAracPath + ".Otel"
        ], safeHotelCode);

        this.setNestedValues(item, [
          kalemAracPath + ".otelAd",
          kalemAracPath + ".OtelAd"
        ], safeHotelName || safeHotelCode);
      }

      var routeText = row.Route || this.buildRouteText(row.From || row.PickupPoint, row.To || row.DropPoint);

      this.setNestedValues(item, [
        kalemAracPath + ".bolge",
        kalemAracPath + ".Bolge",
        "route",
        "Route"
      ], routeText);

      if (row.Note != null) {
        item.aciklama = row.Note;
        item.tedarikciAciklama = row.Note;
        item.Aciklama = row.Note;
        item.TedarikciAciklama = row.Note;
      }

      if (companyCode || companyName) {
        if (!item.satici) {
          item.satici = this.createLookupObject(companyCode, companyName, 2);
        } else {
          if (companyCode) {
            item.satici.kod = companyCode;
            item.satici.Kod = companyCode;
          }

          if (companyName) {
            item.satici.isim = companyName;
            item.satici.Isim = companyName;
          }
        }
      }

      var guideObject = this.createLookupObject(guideCode, guideName, 6);

      if (guideObject) {
        this.setNestedValues(item, [
          kalemAracPath + ".rehber",
          kalemAracPath + ".Rehber"
        ], guideObject);
      }

      this.setNestedValues(item, [
        kalemAracPath + ".rehberKod",
        kalemAracPath + ".RehberKod"
      ], guideCode || guideName);

      this.setNestedValues(item, [
        kalemAracPath + ".rehberAd",
        kalemAracPath + ".RehberAd"
      ], guideName || guideCode);

      if (row.TurKodu != null) {
        item.turKodu = row.TurKodu;
        item.TurKodu = row.TurKodu;

        this.setNestedValues(item, [
          kalemAracPath + ".turKodu",
          kalemAracPath + ".TurKodu"
        ], row.TurKodu);
      }

      if (row.TasimaTipi != null) {
        this.setNestedValues(item, [
          kalemAracPath + ".tasimaTipi",
          kalemAracPath + ".TasimaTipi"
        ], row.TasimaTipi);
      }

      var operationDate = this.normalizeDateForSave(row.Date);

      if (operationDate) {
        item.donem1 = operationDate;
        item.Donem1 = operationDate;
        item.donem2 = operationDate;
        item.Donem2 = operationDate;

        this.setNestedValues(item, [
          kalemAracPath + ".tarih",
          kalemAracPath + ".Tarih",
          kalemAracPath + ".transferTarihi",
          kalemAracPath + ".TransferTarihi"
        ], operationDate);

        if (item.baseKalem) {
          item.baseKalem.tarih = operationDate;
          item.baseKalem.Tarih = operationDate;
          item.baseKalem.transferTarihi = operationDate;
          item.baseKalem.TransferTarihi = operationDate;
        }

        if (item.BaseKalem) {
          item.BaseKalem.tarih = operationDate;
          item.BaseKalem.Tarih = operationDate;
          item.BaseKalem.transferTarihi = operationDate;
          item.BaseKalem.TransferTarihi = operationDate;
        }
      }
    },
    prepareReservationForSave(rezervasyon) {
      var arrayCopy = JSON.parse(JSON.stringify(rezervasyon || {}));

      if (Array.isArray(arrayCopy.kalemler)) {
        arrayCopy.kalemler.forEach(function(element) {
          if (element.acenteKomisyon != null && element.acenteKomisyon.DovizTutar == 0) {
            element.acenteKomisyon = null;
          }

          if (element.kalemRentACar != null) {
            element.donem1 = element.kalemRentACar.alisTarih;
          }
        });
      }

      return arrayCopy;
    },
    applyEditedRowToTable() {
      this.syncLookupFieldsToForm();
      this.syncAgencyRouteFieldsToForm();

      if (!this.rowEditOriginalRow) {
        return;
      }

      var headers = this.rowEditTableName === "driver"
        ? this.driverHeaders
        : this.agencyHeaders;

      for (var i = 0; i < headers.length; i++) {
        var field = headers[i].value;
        var tableValue = this.rowEditForm[field];

        if (this.isDateField(field)) {
          tableValue = this.normalizeDateForRowDisplay(tableValue);
        }

        this.$set(this.rowEditOriginalRow, field, tableValue);
      }

      var originalItems = this.rowEditTableName === "driver"
        ? this.driverOriginalItems
        : this.agencyOriginalItems;

      var original = this.findOriginalRow(originalItems, this.rowEditOriginalRow.__rowKey);

      if (original) {
        for (var h = 0; h < headers.length; h++) {
          var originalField = headers[h].value;
          var originalValue = this.rowEditForm[originalField];

          if (this.isDateField(originalField)) {
            originalValue = this.normalizeDateForRowDisplay(originalValue);
          }

          this.$set(original, originalField, originalValue);
        }
      }
    },
    saveRowEditDialog() {
      if (!this.rowEditOriginalRow) {
        this.text1 = this.$t("Select-A-Row");
        this.snackbar = true;
        return;
      }

      this.syncLookupFieldsToForm();
      this.syncAgencyRouteFieldsToForm();

      var pnrNo = this.getRowPnrNo(this.rowEditOriginalRow);

      if (!pnrNo) {
        this.text1 = this.$t("PNR-Not-Found");
        this.snackbar = true;
        return;
      }

      this.rowEditLoading = true;
      this.progress = true;
      this.showWaitDialog(
        this.$t("Please-Wait"),
        this.$t("Updating-Reservation")
      );

      var loadParams = {
        PNR_No: pnrNo
      };

      tool.http_post(this, "RezervasyonLoad", loadParams)
        .then((response) => {
          if (!response.body || response.body.Status !== true) {
            var loadMessage = response.body && response.body.ErrorList && response.body.ErrorList.length
              ? response.body.ErrorList[0]
              : this.$t("Reservation-Could-Not-Be-Loaded");

            throw {
              isBusinessError: true,
              message: loadMessage
            };
          }

          var rezervasyon = response.body.data;
          var targetItem = this.findReservationTransferItem(rezervasyon, this.rowEditOriginalRow);

          if (!targetItem) {
            throw {
              isBusinessError: true,
              message: this.$t("Reservation-Item-Not-Found")
            };
          }

          this.applyEditedRowToReservationItem(targetItem, this.rowEditForm);

          var saveParams = {
            Rezervasyon: this.prepareReservationForSave(rezervasyon)
          };

          return tool.http_post(this, "RezervasyonKaydet", saveParams);
        })
        .then((response) => {
          if (response.body && response.body.Status === true) {
            this.applyEditedRowToTable();
            this.rowEditDialog = false;
            this.rowEditTableName = "";
            this.rowEditOriginalRow = null;
            this.rowEditForm = {};
            this.rowEditLookup = {
              Company: null,
              Hotel: null,
              Vehicle: null,
              Guide: null
            };
            this.text1 = this.$t("Reservation-Updated-Successfully");
            this.snackbar = true;
            return;
          }

          var saveMessage = response.body && response.body.ErrorList && response.body.ErrorList.length
            ? response.body.ErrorList[0]
            : this.$t("Reservation-Could-Not-Be-Updated");

          throw {
            isBusinessError: true,
            message: saveMessage
          };
        })
        .catch((response) => {
          if (response && response.isBusinessError) {
            this.text1 = response.message;
            this.snackbar = true;
            return;
          }

          this.HataYonetimi(
            response,
            this.rowEditForm,
            this.$t("Reservation-Could-Not-Be-Updated")
          );
        })
        .then(() => {
          this.rowEditLoading = false;
          this.progress = false;
          this.hideWaitDialog();
        });
    },
    getDirectionText(value) {
      for (var i = 0; i < this.transferDirectionItems.length; i++) {
        if (this.transferDirectionItems[i].value === value) {
          return this.transferDirectionItems[i].text;
        }
      }

      return this.$t("All");
    },
    countByDirection(items, direction) {
      if (!Array.isArray(items) || !items.length) {
        return 0;
      }

      return items.filter(function(item) {
        if (!item || !item.Direction) {
          return false;
        }

        return String(item.Direction).toLowerCase() === String(direction).toLowerCase();
      }).length;
    },
    twoDigit(value) {
      value = Number(value || 0);

      if (value < 10) {
        return "0" + value;
      }

      return String(value);
    },
    formatDateForApi(value) {
      if (!value) {
        return "";
      }

      if (value instanceof Date) {
        return (
          value.getFullYear() +
          "-" +
          this.twoDigit(value.getMonth() + 1) +
          "-" +
          this.twoDigit(value.getDate())
        );
      }

      var text = String(value).trim();

      if (/^\d{4}-\d{2}-\d{2}/.test(text)) {
        return text.substring(0, 10);
      }

      if (/^\d{2}\.\d{2}\.\d{4}$/.test(text)) {
        var parts = text.split(".");
        return parts[2] + "-" + parts[1] + "-" + parts[0];
      }

      return text;
    },
    formatDateForDisplay(value) {
      var text = this.formatDateForApi(value);

      if (!text) {
        return "";
      }

      if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
        var parts = text.split("-");
        return parts[2] + "." + parts[1] + "." + parts[0];
      }

      return text;
    },
    displayFilterDate(filter) {
      var startDate = this.formatDateForDisplay(filter.startDate);
      var endDate = this.formatDateForDisplay(filter.endDate);

      if (startDate && endDate) {
        return startDate + " - " + endDate;
      }

      if (startDate) {
        return startDate;
      }

      if (endDate) {
        return endDate;
      }

      return "-";
    },
    buildRouteText(from, to) {
      var cleanFrom = from == null ? "" : String(from).trim();
      var cleanTo = to == null ? "" : String(to).trim();

      if (cleanFrom && cleanTo) {
        return cleanFrom + " - " + cleanTo;
      }

      if (cleanFrom) {
        return cleanFrom;
      }

      if (cleanTo) {
        return cleanTo;
      }

      return "";
    },
    splitRouteText(route) {
      var text = route == null ? "" : String(route).trim();

      if (!text) {
        return {
          from: "",
          to: ""
        };
      }

      var parts = text.split(" - ");

      if (parts.length >= 2) {
        return {
          from: parts[0].trim(),
          to: parts.slice(1).join(" - ").trim()
        };
      }

      parts = text.split("→");

      if (parts.length >= 2) {
        return {
          from: parts[0].trim(),
          to: parts.slice(1).join("→").trim()
        };
      }

      return {
        from: text,
        to: ""
      };
    },
    syncAgencyRouteFieldsToForm() {
      if (this.rowEditTableName !== "agency" || !this.rowEditForm) {
        return;
      }

      var from = this.rowEditForm.From == null ? "" : String(this.rowEditForm.From).trim();
      var to = this.rowEditForm.To == null ? "" : String(this.rowEditForm.To).trim();

      if ((!from || !to) && this.rowEditForm.Route) {
        var routeParts = this.splitRouteText(this.rowEditForm.Route);

        if (!from) {
          from = routeParts.from;
          this.$set(this.rowEditForm, "From", from);
        }

        if (!to) {
          to = routeParts.to;
          this.$set(this.rowEditForm, "To", to);
        }
      }

      this.$set(this.rowEditForm, "Route", this.buildRouteText(from, to));
    },
    getNullablePnr(value) {
      var pnrNo = String(value || "").trim();

      if (!pnrNo) {
        return null;
      }

      var numberValue = Number(pnrNo);

      if (!numberValue || numberValue <= 0) {
        return null;
      }

      return numberValue;
    },
    validateTransferFilter(filter, title) {
      var pnrNo = this.getNullablePnr(filter.pnrNo);
      var startDate = this.formatDateForApi(filter.startDate);
      var endDate = this.formatDateForApi(filter.endDate);

      if (!pnrNo && (!startDate || !endDate)) {
        this.text1 = this.$t("Date-Range-Or-PNR-Required");
        this.snackbar = true;
        return false;
      }

      if (startDate && endDate) {
        var start = new Date(startDate);
        var end = new Date(endDate);

        if (start > end) {
          this.text1 = this.$t("Start-Date-Cannot-Be-Greater-Than-End-Date");
          this.snackbar = true;
          return false;
        }
      }

      return true;
    },
    validateAgencyForm() {
      if (!this.$refs.formagency.validate()) {
        return false;
      }

      return this.validateTransferFilter(
        this.agencyFilter,
        this.$t("Agency-Schedule")
      );
    },
    validateDriverForm() {
      if (!this.$refs.formdriver.validate()) {
        return false;
      }

      return this.validateTransferFilter(
        this.driverFilter,
        this.$t("Driver-Schedule")
      );
    },
    createQueryString(filter) {
      var pnrNo = this.getNullablePnr(filter.pnrNo);
      var startDate = this.formatDateForApi(filter.startDate);
      var endDate = this.formatDateForApi(filter.endDate);
      var query = [];

      if (startDate) {
        query.push("startDate=" + encodeURIComponent(startDate));
      }

      if (endDate) {
        query.push("endDate=" + encodeURIComponent(endDate));
      }

      if (pnrNo) {
        query.push("pnrNo=" + encodeURIComponent(pnrNo));
      }

      query.push("transferDirection=" + encodeURIComponent(filter.transferDirection || "all"));
      query.push("sortBy=" + encodeURIComponent(filter.sortBy || "dateTime"));
      query.push("sortDirection=" + encodeURIComponent(filter.sortDirection || "asc"));

      return "?" + query.join("&");
    },
    createFilterFileName(filter) {
      var pnrNo = this.getNullablePnr(filter.pnrNo);

      if (pnrNo) {
        return String(pnrNo);
      }

      var startDate = this.formatDateForApi(filter.startDate);
      var endDate = this.formatDateForApi(filter.endDate);

      if (startDate && endDate) {
        return startDate.replace(/-/g, "") + "_" + endDate.replace(/-/g, "");
      }

      return "DateRange";
    },
    createAgencyPdfFileName() {
      var direction = this.getDirectionText(this.agencyFilter.transferDirection);
      var filterName = this.createFilterFileName(this.agencyFilter);

      return "AgencyTransferSchedule_" + direction + "_" + filterName + ".pdf";
    },
    createDriverPdfFileName() {
      var direction = this.getDirectionText(this.driverFilter.transferDirection);
      var filterName = this.createFilterFileName(this.driverFilter);

      return "DriverTransferSchedule_" + direction + "_" + filterName + ".pdf";
    },
    showWaitDialog(title, message) {
      this.loadingDialogTitle = title || this.$t("Please-Wait");
      this.loadingDialogMessage = message || this.$t("Operation-Is-Being-Prepared");
      this.loadingDialog = true;
    },
    hideWaitDialog() {
      this.loadingDialog = false;
    },
    HataYonetimi(response, request, baslik) {
      if (response && response.status === 500) {
        this.$refs.hatadialog.open(response, request, baslik);
      } else if (response && response.status === 404) {
        this.text1 = baslik + " - " + this.$t("Endpoint-Not-Found");
        this.snackbar = true;
      } else {
        this.text1 = this.$t("Service-Unavailable") + " - " + baslik;
        this.snackbar = true;
      }
    },
    normalizeListResponse(body) {
      if (!body) {
        return [];
      }

      if (body.rows && Array.isArray(body.rows)) {
        return body.rows;
      }

      if (body.Rows && Array.isArray(body.Rows)) {
        return body.Rows;
      }

      if (body.data && Array.isArray(body.data)) {
        return body.data;
      }

      if (body.Data && Array.isArray(body.Data)) {
        return body.Data;
      }

      return [];
    },
    getAgencyList() {
      if (!this.validateAgencyForm()) {
        return;
      }

      this.progress = true;
      this.agencyListLoading = true;
      this.agencyHasSearched = true;
      this.stopEditCell();
      this.showWaitDialog(
        this.$t("Please-Wait"),
        this.$t("Agency-Transfer-Schedule-Is-Loading")
      );

      var endpoint =
        "TransferOperationScheduleList" +
        this.createQueryString(this.agencyFilter);

      var params = {};

      tool.http_post(this, endpoint, params)
        .then((response) => {
          var rows = this.normalizeListResponse(response.body);

          this.agencyItems = this.prepareRows(rows, this.agencyHeaders, "agency");
          this.agencyOriginalItems = this.cloneRows(this.agencyItems);

          if (this.agencyItems.length === 0) {
            this.text1 = this.$t("No-Records-Found-For-Agency-Transfer-Schedule");
            this.snackbar = true;
          }
        })
        .catch((response) => {
          this.agencyItems = [];
          this.agencyOriginalItems = [];
          this.HataYonetimi(response, params, this.$t("Agency-Transfer-Schedule-Could-Not-Be-Retrieved"));
        })
        .then(() => {
          this.progress = false;
          this.agencyListLoading = false;
          this.hideWaitDialog();
        });
    },
    getDriverList() {
      if (!this.validateDriverForm()) {
        return;
      }

      this.progress = true;
      this.driverListLoading = true;
      this.driverHasSearched = true;
      this.stopEditCell();
      this.showWaitDialog(
        this.$t("Please-Wait"),
        this.$t("Driver-Transfer-Schedule-Is-Loading")
      );

      var endpoint =
        "TransferOperationDriverDetailList" +
        this.createQueryString(this.driverFilter);

      var params = {};

      tool.http_post(this, endpoint, params)
        .then((response) => {
          var rows = this.normalizeListResponse(response.body);

          this.driverItems = this.prepareRows(rows, this.driverHeaders, "driver");
          this.driverOriginalItems = this.cloneRows(this.driverItems);

          if (this.driverItems.length === 0) {
            this.text1 = this.$t("No-Records-Found-For-Driver-Transfer-Schedule");
            this.snackbar = true;
          }
        })
        .catch((response) => {
          this.driverItems = [];
          this.driverOriginalItems = [];
          this.HataYonetimi(response, params, this.$t("Driver-Transfer-Schedule-Could-Not-Be-Retrieved"));
        })
        .then(() => {
          this.progress = false;
          this.driverListLoading = false;
          this.hideWaitDialog();
        });
    },
    downloadAgencyPdf() {
      if (!this.validateAgencyForm()) {
        return;
      }

      if (!this.agencyItems || this.agencyItems.length === 0) {
        this.text1 = this.$t("Retrieve-Agency-List-Before-PDF");
        this.snackbar = true;
        return;
      }

      this.stopEditCell();
      this.progress = true;
      this.agencyPdfLoading = true;
      this.showWaitDialog(
        this.$t("Please-Wait"),
        this.$t("Agency-PDF-Is-Being-Prepared")
      );

      var endpoint = "Coper/TransferOperationScheduleEditedPdfDownload";

      var params = {
        startDate: this.formatDateForApi(this.agencyFilter.startDate),
        endDate: this.formatDateForApi(this.agencyFilter.endDate),
        pnrNo: this.getNullablePnr(this.agencyFilter.pnrNo),
        transferDirection: this.agencyFilter.transferDirection || "all",
        sortBy: this.agencyFilter.sortBy || "dateTime",
        sortDirection: this.agencyFilter.sortDirection || "asc",
        rows: this.sanitizeRowsForPdf(this.agencyItems, this.agencyHeaders)
      };

      tool.api_post_FileDownload(this, endpoint, params)
        .then((response) => {
          tool.CreateDownloadLink(response, this.createAgencyPdfFileName());
        })
        .catch((response) => {
          this.HataYonetimi(response, params, this.$t("Agency-Transfer-Schedule-PDF-Could-Not-Be-Downloaded"));
        })
        .then(() => {
          this.progress = false;
          this.agencyPdfLoading = false;
          this.hideWaitDialog();
        });
    },
    downloadDriverPdf() {
      if (!this.validateDriverForm()) {
        return;
      }

      if (!this.driverItems || this.driverItems.length === 0) {
        this.text1 = this.$t("Retrieve-Driver-List-Before-PDF");
        this.snackbar = true;
        return;
      }

      this.stopEditCell();
      this.progress = true;
      this.driverPdfLoading = true;
      this.showWaitDialog(
        this.$t("Please-Wait"),
        this.$t("Driver-PDF-Is-Being-Prepared")
      );

      var endpoint = "Coper/TransferOperationDriverDetailEditedPdfDownload";

      var params = {
        startDate: this.formatDateForApi(this.driverFilter.startDate),
        endDate: this.formatDateForApi(this.driverFilter.endDate),
        pnrNo: this.getNullablePnr(this.driverFilter.pnrNo),
        transferDirection: this.driverFilter.transferDirection || "all",
        sortBy: this.driverFilter.sortBy || "dateTime",
        sortDirection: this.driverFilter.sortDirection || "asc",
        rows: this.sanitizeRowsForPdf(this.driverItems, this.driverHeaders)
      };

      tool.api_post_FileDownload(this, endpoint, params)
        .then((response) => {
          tool.CreateDownloadLink(response, this.createDriverPdfFileName());
        })
        .catch((response) => {
          this.HataYonetimi(response, params, this.$t("Driver-Transfer-Schedule-PDF-Could-Not-Be-Downloaded"));
        })
        .then(() => {
          this.progress = false;
          this.driverPdfLoading = false;
          this.hideWaitDialog();
        });
    },
    prepareRows(rows, headers, tableName) {
      var prepared = [];

      if (!Array.isArray(rows)) {
        return prepared;
      }

      for (var i = 0; i < rows.length; i++) {
        var source = rows[i] || {};
        var row = {};

        for (var prop in source) {
          if (Object.prototype.hasOwnProperty.call(source, prop)) {
            row[prop] = source[prop] == null ? "" : source[prop];
          }
        }

        for (var h = 0; h < headers.length; h++) {
          var field = headers[h].value;

          if (row[field] == null) {
            row[field] = "";
          }
        }

        if (tableName === "agency") {
          var routeParts = this.splitRouteText(row.Route);

          if (!row.From) {
            row.From = source.From || source.from || source.Nerden || source.nerden || source.PickupPoint || routeParts.from || "";
          }

          if (!row.To) {
            row.To = source.To || source.to || source.Nereye || source.nereye || source.DropPoint || routeParts.to || "";
          }

          if (!row.Route) {
            row.Route = this.buildRouteText(row.From, row.To);
          }
        }

        if (tableName === "driver" && !row.Date) {
          row.Date = this.normalizeDateForRowDisplay(
            this.getFirstExistingValue(source, [
              "Date",
              "date",
              "Tarih",
              "tarih",
              "Donem1",
              "donem1",
              "DONEM1",
              "TransferDate",
              "transferDate",
              "OperationDate",
              "operationDate"
            ])
          );
        }

        if (tableName === "driver" && row.Date) {
          row.Date = this.normalizeDateForRowDisplay(row.Date);
        }

        row.__rowKey = tableName + "_" + i + "_" + String(row.Reference || "") + "_" + String(row.FlightNo || "") + "_" + String(row.Time || row.PickupTime || "");

        prepared.push(row);
      }

      return prepared;
    },
    cloneRows(rows) {
      var result = [];

      if (!Array.isArray(rows)) {
        return result;
      }

      for (var i = 0; i < rows.length; i++) {
        var row = {};
        var source = rows[i] || {};

        for (var prop in source) {
          if (Object.prototype.hasOwnProperty.call(source, prop)) {
            row[prop] = source[prop];
          }
        }

        result.push(row);
      }

      return result;
    },
    sanitizeRowsForPdf(rows, headers) {
      var result = [];

      if (!Array.isArray(rows)) {
        return result;
      }

      for (var i = 0; i < rows.length; i++) {
        var source = rows[i] || {};
        var row = {};

        for (var h = 0; h < headers.length; h++) {
          var field = headers[h].value;
          row[field] = source[field] == null ? "" : source[field];
        }

        if (row.Route == null || row.Route === "") {
          row.Route = this.buildRouteText(row.From, row.To);
        }

        result.push(row);
      }

      return result;
    },
    resetAgencyChanges() {
      this.stopEditCell();
      this.agencyItems = this.cloneRows(this.agencyOriginalItems);
      this.text1 = this.$t("Agency-Schedule-Changes-Undone");
      this.snackbar = true;
    },
    resetDriverChanges() {
      this.stopEditCell();
      this.driverItems = this.cloneRows(this.driverOriginalItems);
      this.text1 = this.$t("Driver-Schedule-Changes-Undone");
      this.snackbar = true;
    },
    getColumnField(column) {
      if (!column) {
        return "";
      }

      return column.value || column.field || column.key || "";
    },
    getRowKey(item, fallbackIndex) {
      if (item && item.__rowKey) {
        return item.__rowKey;
      }

      return "row_" + fallbackIndex;
    },
    startEditCell(tableName, item, column) {
      if (!item || !column) {
        return;
      }

      var field = this.getColumnField(column);

      if (!field) {
        return;
      }

      if (this.isReadOnlyColumn(field)) {
        return;
      }

      if (column.editable === false) {
        return;
      }

      this.editingCell.tableName = tableName;
      this.editingCell.rowKey = item.__rowKey || "";
      this.editingCell.field = field;
    },
    stopEditCell() {
      this.editingCell.tableName = "";
      this.editingCell.rowKey = "";
      this.editingCell.field = "";
    },
    isEditingCell(tableName, item, column) {
      if (!item || !column) {
        return false;
      }

      var field = this.getColumnField(column);

      if (!field) {
        return false;
      }

      return (
        this.editingCell.tableName === tableName &&
        this.editingCell.rowKey === item.__rowKey &&
        this.editingCell.field === field
      );
    },
    setCellValue(item, column, value) {
      if (!item || !column) {
        return;
      }

      var field = this.getColumnField(column);

      if (!field) {
        return;
      }

      this.$set(item, field, value);
    },
    isReadOnlyColumn(field) {
      var readOnlyColumns = [
        "Reference",
        "PNR",
        "PNR_No",
        "PnrNo",
        "pnrNo",
        "pNR_No"
      ];

      return readOnlyColumns.indexOf(field) > -1;
    },
    displayReportTableCellValue(slotProps) {
      if (!slotProps) {
        return "-";
      }

      var value = slotProps.value;

      if ((value == null || value === "") && slotProps.item && slotProps.column) {
        var field = this.getColumnField(slotProps.column);
        value = slotProps.item[field];
      }

      if (value == null || value === "") {
        return "-";
      }

      return value;
    },
    isChangedCell(tableName, item, column) {
      if (!item || !column) {
        return false;
      }

      var field = this.getColumnField(column);

      if (!field) {
        return false;
      }

      var originalItems = tableName === "agency"
        ? this.agencyOriginalItems
        : this.driverOriginalItems;

      var original = this.findOriginalRow(originalItems, item.__rowKey);

      if (!original) {
        return false;
      }

      var currentValue = item[field] == null ? "" : String(item[field]);
      var originalValue = original[field] == null ? "" : String(original[field]);

      return currentValue !== originalValue;
    },
    findOriginalRow(originalItems, rowKey) {
      if (!Array.isArray(originalItems)) {
        return null;
      }

      for (var i = 0; i < originalItems.length; i++) {
        if (originalItems[i].__rowKey === rowKey) {
          return originalItems[i];
        }
      }

      return null;
    },
    countChangedRows(currentRows, originalRows, headers) {
      if (!Array.isArray(currentRows) || !Array.isArray(originalRows)) {
        return 0;
      }

      var count = 0;

      for (var i = 0; i < currentRows.length; i++) {
        var current = currentRows[i];
        var original = this.findOriginalRow(originalRows, current.__rowKey);

        if (!original) {
          continue;
        }

        var changed = false;

        for (var h = 0; h < headers.length; h++) {
          var field = headers[h].value;
          var currentValue = current[field] == null ? "" : String(current[field]);
          var originalValue = original[field] == null ? "" : String(original[field]);

          if (currentValue !== originalValue) {
            changed = true;
            break;
          }
        }

        if (changed) {
          count++;
        }
      }

      return count;
    }
  }
};
</script>

<style scoped>
.transfer-operation-page {
  min-height: 100vh;
  background: #f1f3f5;
}

.page-card {
  min-height: 100vh;
}

.page-toolbar {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

.page-container {
  padding-top: 22px;
}

.main-card {
  background: #ffffff;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.main-tabs {
  background: #ffffff;
}

.main-tab {
  font-weight: 700;
  letter-spacing: 0.2px;
}

.tab-content-card {
  padding: 18px 20px 20px 20px;
  background: #ffffff;
}

.filter-card {
  background: #ffffff;
  border-radius: 4px;
  margin-bottom: 16px;
}

.tab-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #edf2f7;
}

.tab-title {
  font-size: 20px;
  font-weight: 800;
  color: #172033;
}

.tab-description {
  margin-top: 5px;
  max-width: 760px;
  font-size: 13px;
  color: #64748b;
  line-height: 1.45;
}

.tab-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}

.filter-row {
  padding-top: 18px;
  margin-left: -6px;
  margin-right: -6px;
}

.filter-row .flex {
  padding-left: 6px;
  padding-right: 6px;
}

.summary-cards-row {
  margin-top: 18px;
  margin-bottom: 4px;
}

.summary-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 14px 12px;
  min-height: 84px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.05);
}

.summary-card-title {
  font-size: 12px;
  color: #607d8b;
  margin-bottom: 8px;
  font-weight: 700;
}

.summary-card-value {
  font-size: 22px;
  font-weight: 800;
  color: #263238;
  line-height: 1.2;
  word-break: break-word;
}

.summary-card-value-small {
  font-size: 17px;
}

.summary-pnr {
  border-top: 4px solid #607d8b;
}

.summary-date {
  border-top: 4px solid #2196f3;
}

.summary-direction {
  border-top: 4px solid #673ab7;
}

.summary-count {
  border-top: 4px solid #00acc1;
}

.summary-arrival {
  border-top: 4px solid #4caf50;
}

.summary-departure {
  border-top: 4px solid #ff9800;
}

.summary-changed {
  border-top: 4px solid #f44336;
}

.row-edit-dialog-card {
  border-radius: 8px;
}

.row-edit-dialog-title {
  padding: 18px 22px 14px 22px;
}

.row-edit-dialog-main-title {
  font-size: 18px;
  font-weight: 800;
  color: #263238;
}

.row-edit-dialog-sub-title {
  margin-top: 3px;
  font-size: 13px;
  font-weight: 600;
  color: #607d8b;
}

.row-edit-dialog-body {
  max-height: 560px;
  overflow-y: auto;
  padding: 18px 22px !important;
}

.row-edit-field-wrap {
  margin-bottom: 12px;
}

.row-edit-field {
  margin-bottom: 0;
}

.row-edit-field-wrap >>> .v-input {
  margin-top: 0;
  padding-top: 0;
}

.wait-dialog-card {
  border-radius: 12px;
}

.wait-dialog-content {
  min-height: 118px;
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 26px 24px !important;
}

.wait-dialog-text {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.wait-dialog-title {
  font-size: 17px;
  font-weight: 800;
  color: #263238;
}

.wait-dialog-message {
  font-size: 13px;
  font-weight: 600;
  color: #607d8b;
  line-height: 1.4;
}

.table-info-row {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-start;
}

.table-info {
  min-height: 40px;
  padding: 9px 12px;
  border-radius: 8px;
  background: #eef6ff;
  border: 1px solid #d6eaff;
  color: #36516c;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.report-table-host {
  width: 100%;
}

.transfer-edit-cell {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 28px;
  padding: 3px 4px;
  border-radius: 4px;
  cursor: pointer;
}

.transfer-edit-cell:hover {
  background: #eef6ff;
  color: #1565c0;
}

.transfer-edit-cell-readonly {
  cursor: default;
  color: #64748b;
}

.transfer-edit-cell-readonly:hover {
  background: transparent;
  color: #64748b;
}

.transfer-edit-cell-active {
  padding: 0;
  background: #e3f2fd;
}

.transfer-edit-cell-changed {
  background: #fff8e1;
  font-weight: 800;
}

.editable-input {
  width: 100%;
  min-width: 120px;
}

.editable-input >>> .v-input__control {
  min-height: 30px;
}

.editable-input >>> .v-input__slot {
  min-height: 30px;
  padding: 0 8px !important;
  box-shadow: none !important;
  border: 1px solid #64b5f6;
  background: #ffffff !important;
}

.table-footer {
  padding: 12px 4px 0 4px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 20px;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

@media (max-width: 960px) {
  .tab-header {
    flex-direction: column;
  }

  .tab-actions {
    justify-content: flex-start;
  }

  .summary-cards-row {
    margin-top: 14px;
  }
}
</style>
